// This file is now primarily handled by AuthContext.js
// Keep this file for any additional auth utilities if needed

import { sendPasswordResetEmail, updateProfile } from "firebase/auth";
import { auth } from "./firebase";
import { getFriendlyAuthError } from "../utils/authErrors";

// Send password reset email
export const sendPasswordReset = async (email) => {
	try {
		await sendPasswordResetEmail(auth, email);
		return { success: true };
	} catch (error) {
		console.error("Password reset error:", error);
		throw new Error(
			getFriendlyAuthError(
				error,
				"Failed to send password reset email. Please try again.",
			),
		);
	}
};

// Update user profile
export const updateUserProfile = async (updates) => {
	try {
		if (auth.currentUser) {
			await updateProfile(auth.currentUser, updates);
			return { success: true };
		} else {
			throw new Error("No user is currently logged in");
		}
	} catch (error) {
		console.error("Profile update error:", error);
		throw new Error(error.message || "Failed to update profile");
	}
};

// Get current user
export const getCurrentUser = () => {
	return auth.currentUser;
};

// Check if user is authenticated
export const isAuthenticated = () => {
	return !!auth.currentUser;
};
